import { get } from '../utils/axios'

export const getDropPaymentGroupsAPI = async (param) => {
  return await get('payment/groups', param)
}

export const getReportDropGroupsAPI = async (param) => {
  return await get('report/drop/groups', param)
}

export const getReportDropDivisionsAPI = async (param) => {
  return await get('report/drop/divisions', param)
}

export const getReportDropDepartmentsAPI = async (param) => {
  return await get('report/drop/departments', param)
}

export const getReportDropTeamsAPI = async (param) => {
  return await get('report/drop/teams', param)
}
